import { buildModelManager } from "../builder.js";
const DefaultDuplicativeCustomerDiscountBlockedSelection = {
  __typename: true,
  id: true,
  checkoutEmail: true,
  checkoutPhone: true,
  checkoutToken: true,
  createdAt: true,
  discountCode: true,
  orderList: true,
  shippingAddressAddress1: true,
  shippingAddressAddress2: true,
  shippingAddressCity: true,
  shippingAddressCountry: true,
  shippingAddressPhone: true,
  shippingAddressProvince: true,
  shippingAddressZip: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "duplicativeCustomerDiscountBlocked";
const pluralModelApiIdentifier = "duplicativeCustomerDiscountBlockeds";
;
;
;
;
;
;
const DuplicativeCustomerDiscountBlockedManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultDuplicativeCustomerDiscountBlockedSelection,
  [
    {
      type: "findOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "findMany",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "findFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "maybeFindFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection,
      namespace: null
    },
    {
      type: "action",
      operationName: "createDuplicativeCustomerDiscountBlocked",
      operationReturnType: "CreateDuplicativeCustomerDiscountBlocked",
      functionName: "create",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        duplicativeCustomerDiscountBlocked: {
          required: false,
          type: "CreateDuplicativeCustomerDiscountBlockedInput"
        }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection
    },
    {
      type: "action",
      operationName: "bulkCreateDuplicativeCustomerDiscountBlockeds",
      functionName: "bulkCreate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "create",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkCreateDuplicativeCustomerDiscountBlockedsInput!]"
        }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultDuplicativeCustomerDiscountBlockedSelection
    }
  ]
);
export {
  DefaultDuplicativeCustomerDiscountBlockedSelection,
  DuplicativeCustomerDiscountBlockedManager
};
//# sourceMappingURL=DuplicativeCustomerDiscountBlocked.js.map
